module.exports = __webpack_public_path__ + "briefcase.svg?a48cb4931846a871f644f39704c75cfe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/briefcase.svg
// module id = 38
// module chunks = 0